import "./choices.scss";
window.Choices = require("../../node_modules/choices.js/public/assets/scripts/choices");
